import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { faqItems } from './data';

const Faq = () => {
  return (
    <div className='page__content'>
      <Box sx={{ py: 8, maxWidth: '700px', mx: 'auto' }}>
        <Typography
          textAlign={'center'}
          fontSize={{ xs: 26, lg: 44 }}
          fontWeight={600}
          color='#070A0D'
          lineHeight={1}
          mb={3}
          component='h3'
        >
          FAQ
        </Typography>

        {faqItems.map((item, index) => (
          <Accordion
            key={index}
            defaultExpanded={index === 0}
            disableGutters
            sx={{
              borderBottom: '1px solid #EBEBEB',
              boxShadow: 'none',
              py: 2,
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                fontWeight={500}
                fontSize={{ xs: 15, lg: 16 }}
                color='#3A3E50'
                lineHeight={1.25}
                component='h5'
              >
                {item.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant='body2' component='div' color='#8D91A0'>
                {item.content}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </div>
  );
};

export default Faq;
